/**
 * Normaliza texto para comparar sin acentos, mayusculas ni puntuacion. Conserva digitos
 * y separa los tokens por un unico espacio.
 *
 * @example normalizeText('¡Muéstrame las VENTAS por región!') // 'muestrame las ventas por region'
 */
export function normalizeText(text: string): string {
  return text
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export const tokenize = (text: string): string[] => {
  const normalized = normalizeText(text);
  return normalized === '' ? [] : normalized.split(' ');
};

/**
 * Raiz simple para plural/singular en espanol (`ventas` -> `venta`, `regiones` -> `region`).
 * Es intencionalmente conservadora: solo recorta sufijos de plural frecuentes.
 */
export function stem(token: string): string {
  if (token.length > 4 && /(?:ones|iones)$/.test(token)) return token.slice(0, -2);
  if (token.length > 4 && /[lnrdzsjy]es$/.test(token)) return token.slice(0, -2);
  if (token.length > 3 && /[aeo]s$/.test(token)) return token.slice(0, -1);
  return token;
}

/** Forma comparable de un termino: tokens normalizados y reducidos a su raiz. */
export const comparable = (text: string): string => tokenize(text).map(stem).join(' ');
